import { useEffect, useRef, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { classNames } from '../../utils/classNames';

function DropdownMenu({ label, icon: Icon, items, align = 'right' }) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClick = (event) => {
      if (!containerRef.current?.contains(event.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div ref={containerRef} className="relative inline-block">
      <button type="button" onClick={() => setOpen((value) => !value)} aria-expanded={open} className="inline-flex h-10 items-center gap-2 rounded-control border bg-white px-3 text-sm font-medium text-content-secondary shadow-xs hover:bg-slate-50">
        {Icon && <Icon className="size-4" aria-hidden="true" />}
        {label}
        <ChevronDown className={classNames('size-4 transition', open && 'rotate-180')} aria-hidden="true" />
      </button>
      {open && (
        <div className={classNames('absolute z-40 mt-2 min-w-52 overflow-hidden rounded-card border bg-white p-1.5 shadow-elevated', align === 'right' ? 'right-0' : 'left-0')} role="menu">
          {items.map((item) => item.separator ? (
            <div key={item.id} className="my-1 border-t" />
          ) : (
            <button
              key={item.id}
              type="button"
              role="menuitem"
              disabled={item.disabled}
              onClick={() => { item.onClick?.(); setOpen(false); }}
              className={classNames('flex w-full items-center gap-2 rounded-md px-3 py-2 text-left text-sm transition disabled:opacity-40', item.danger ? 'text-danger-600 hover:bg-danger-50' : 'text-content-secondary hover:bg-slate-100 hover:text-content-primary')}
            >
              {item.icon && <item.icon className="size-4" aria-hidden="true" />}
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default DropdownMenu;
